import { DialogActions, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PickersActionBarProps } from '@mui/x-date-pickers';
import { ReactElement } from 'react';

import { PoolButton } from '../button/pool-button';

export const PoolDatePickerActionBar = (props: PickersActionBarProps): ReactElement => {
    const { onAccept, onClear, actions, className } = props;

    return (
        <DialogActions className={className}>
            <Stack direction="row-reverse" justifyContent="space-between" sx={{ width: '100%', p: 1 }}>
                {actions?.includes('accept') && (
                    <PoolButton onClick={onAccept} styleType="firstLevel">
                        <FormattedMessage id="app.common.ok" />
                    </PoolButton>
                )}
                {actions?.includes('clear') && (
                    <PoolButton onClick={onClear} styleType="secondLevel">
                        <FormattedMessage id="app.common.delete" />
                    </PoolButton>
                )}
            </Stack>
        </DialogActions>
    );
};
